import { OrderingInitialState, SetCouponCodeAction } from '@reducers/ordering/types';

export const setCouponCode = (state: OrderingInitialState, action: SetCouponCodeAction): OrderingInitialState => ({
  ...state,
  couponState: {
    ...state.couponState,
    couponCode: action.payload.couponCode,
  },
});
